import { Howl } from 'howler';
import { PATH } from '../settings/constants';

const PRELOAD_SOUNDS = [
  'sfx/0-char-show',
  'sfx/1-coffee',
  'sfx/1-char-show',
  'sfx/3-char-0',
  'sfx/3-char-1',
  'sfx/3-char-2',
  'sfx/3-char-3',
  'sfx/3-char-4',
  'sfx/3-char-5',
  'sfx/3-char-6',
  'sfx/4-anim-0',
  'sfx/4-anim-1',
  'sfx/4-anim-2',
  'sfx/steps',
];

export function getSoundSrc(path: string): string[] {
  return [`${PATH.SOUND}${path}.mp3`, `${PATH.SOUND}${path}.ogg`];
}

// --------------------------------------------------------------
// Preload
// --------------------------------------------------------------

export const preloadSounds = (): void => {
  PRELOAD_SOUNDS.forEach((sound) => {
    new Howl({
      src: getSoundSrc(sound),
    });
  });
};

// --------------------------------------------------------------
// SFX
// --------------------------------------------------------------

export const playSfx = (sfx: string, volume = 1): void => {
  new Howl({
    src: getSoundSrc(`sfx/${sfx}`),
    volume,
  }).play();
};

// --------------------------------------------------------------
// Music
// --------------------------------------------------------------

let music: any = null;

export const swapMusic = (id: number | null): void => {
  if (music) {
    music.stop();
  }
  if (id !== null) {
    music = new Howl({
      src: getSoundSrc(`music/${id}`),
      volume: 0.1,
      loop: true,
    });
    music.play();
  }
};

// --------------------------------------------------------------
// Atmo
// --------------------------------------------------------------

let atmo: any = null;

export const swapAtmo = (id: number | null): void => {
  if (atmo) {
    atmo.stop();
  }
  if (id !== null) {
    atmo = new Howl({
      src: getSoundSrc(`atmo/${id}`),
      volume: 0.3,
      loop: true,
    });
    atmo.play();
  }
};

// --------------------------------------------------------------
// Window chars
// --------------------------------------------------------------

const WIN_CHAR_BASE_POOL = [0, 1, 2, 3, 4, 5, 6];
const winCharPool = [...WIN_CHAR_BASE_POOL];
let lastWinChar = -1;

export const playWindowCharSfx = (): void => {
  if (!speechPlaying) {
    if (winCharPool.length === 0) {
      WIN_CHAR_BASE_POOL.forEach((id) => {
        if (id !== lastWinChar) {
          winCharPool.push(id);
        }
      });
    }
    lastWinChar = winCharPool.splice(Math.floor(Math.random() * winCharPool.length), 1)[0];
    playSfx(`3-char-${lastWinChar}`, 0.9);
  }
};

// --------------------------------------------------------------
// Speech
// --------------------------------------------------------------

let speech: any = null;
let speechPlaying = false;

export const playSpeech = (id: string, handleComplete: () => void): void => {
  stopSpeech();
  speechPlaying = true;
  speech = new Howl({
    src: getSoundSrc(`speech/${id}`),
    onend: () => {
      speechPlaying = false;
      handleComplete();
    },
  });
  speech.play();
};

export const stopSpeech = (): void => {
  if (speech) {
    speechPlaying = false;
    speech.stop();
  }
};

export const isSpeechPlaying = (): boolean => {
  return speechPlaying;
};
